import React, { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import './IntroVideo.css';
import { markStoryVideoMissing, storyVideoUrl } from '../utils/storyVideo';
import { tl } from '../utils/inlineI18n';

const SKIP_DELAY_MS = 2000;

// Hikâye görevinin videosu: tam ekran oynar, birkaç saniye sonra "Geç"
// düğmesi çıkar; bitince ya da geçilince kapanır.
const StoryVideo = ({ src, title, onClose }) => {
  const videoRef = useRef(null);
  const [skipVisible, setSkipVisible] = useState(false);
  const [loading, setLoading] = useState(true);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    window.dispatchEvent(new CustomEvent('text2:pause-background-music'));
    const timer = window.setTimeout(() => setSkipVisible(true), SKIP_DELAY_MS);
    const video = videoRef.current;
    if (video) {
      video.play().catch(() => {
        // Otomatik oynatma engellendiyse kontroller görünür; oyuncu kendisi başlatır.
        setLoading(false);
      });
    }
    return () => {
      window.clearTimeout(timer);
      window.dispatchEvent(new CustomEvent('text2:resume-background-music'));
    };
  }, []);

  const close = () => {
    videoRef.current?.pause();
    onClose?.();
  };

  const handleError = () => {
    markStoryVideoMissing(src);
    setFailed(true);
    setLoading(false);
    setSkipVisible(true);
  };

  return createPortal(
    <div className="intro-video story-video" role="dialog" aria-modal="true" aria-label={title || tl('Görev videosu', 'Quest video')}>
      <video
        ref={videoRef}
        className="intro-video__player"
        src={storyVideoUrl(src)}
        playsInline
        autoPlay
        controls
        preload="auto"
        onPlaying={() => setLoading(false)}
        onEnded={close}
        onError={handleError}
      />
      {loading && !failed ? (
        <div className="intro-video__loading" role="status" aria-live="polite">
          <div className="intro-video__loading-text">{tl('Video yükleniyor…', 'Loading video…')}</div>
        </div>
      ) : null}
      {failed ? <div className="intro-video__error">{tl('Bu görevin videosu henüz eklenmemiş.', 'This quest has no video yet.')}</div> : null}
      <button
        type="button"
        className={`intro-video__skip${skipVisible ? ' intro-video__skip--visible' : ''}`}
        onClick={close}
      >
        {failed ? tl('Kapat', 'Close') : tl('Geç', 'Skip')}
      </button>
    </div>,
    document.body
  );
};

export default StoryVideo;
